import { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Lottie from 'lottie-react';
import { useApi } from 'lib/contexts/ApplicationState';

interface Props {
  onClose: () => void;
}

export const CelebrateModal = ({
  onClose,
}: Props) => {
  const API = useApi();

  const [data, setData] = useState<any>();

  useEffect(() => {
    const getAnimation = async () => {
      try {
        const d = await API.getMilestoneCelebrate();
        setData(d);
      } catch (err) {
        // If there is an error fetching the lottie json, just close the modal
        onClose();
      }
    };

    if (!data) {
      getAnimation();
    }
  }, [data, API]);

  return (
    <Dialog
      open
      fullWidth
      maxWidth="xl"
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          margin: 0,
          width: '100%',
        },
      }}
    >
      <div className="relative h-full w-full flex justify-center">
        <div className="absolute right-2 top-2 z-10">
          <IconButton onClick={onClose} aria-label="close modal" className="bg-white text-orange">
            <CloseIcon />
          </IconButton>
        </div>
        <div>
          <Lottie
            animationData={data}
            onLoopComplete={() => onClose()}
            style={{
              minWidth: 700,
              margin: 0,
              overflow: 'hidden',
            }}
          />
        </div>
      </div>
    </Dialog>
  );
};
